import React from 'react';

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
    const pageNumbers = [];

    for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
    }

    return (
        <div>
            <div className="mt-4 mb-2">
                <nav aria-label="...">
                  <ul className="pagination pagination-sm justify-content-center">
                    {pageNumbers.map(number => (
                        <li className="page-link" key={number} onClick={() => onPageChange(number)}>
                            {number}
                        </li>
                    ))}
                  </ul>
                </nav>
            </div>
            {/* <ul>
                {pageNumbers.map(number => (
                    <li key={number} onClick={() => onPageChange(number)}>
                        {number}
                    </li>
                ))}
            </ul> */}
        </div>
    );
};

export default Pagination;